import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getLogHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {

    console.log("action.payload in log saga =>",  endPoint.dynamicList({
			path: "log",
			...action.payload,
		}),);

  const { data } = yield call(
    apiClient.get,
    endPoint.dynamicList({
			path: "log",
			...action.payload,
		}),
  );
    yield put({
      type: types.GET_LOG_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.GET_LOG_ERROR,
      payload,
    });
  }
}

export function* getLogWatcherSaga() {
  yield takeLatest(types.GET_LOG_START, getLogHandlerSaga);
}

//delete

function* deleteLogHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.delete,
      endPoint.deleteDyanamicItem("log", action.payload),
    );
    yield put({
      type: types.DELETE_LOG_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.DELETE_LOG_ERROR,
      payload,
    });
  }
}

export function* deleteLogWatcherSaga() {
  yield takeLatest(types.DELETE_LOG_START, deleteLogHandlerSaga);
}

//single item

function* getSingleLogHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: `log/${action.payload}` }),
    );
    yield put({
      type: types.SINGLE_LOG_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.SINGLE_LOG_ERROR,
      payload,
    });
  }
}

export function* getSingleLogWatcherSaga() {
  yield takeLatest(types.SINGLE_LOG_START, getSingleLogHandlerSaga);
}

